// postdetailsmaincontent.jsx
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { WhatsappShareButton, TelegramShareButton } from 'react-share'
import { ArticleTag } from '../../HomePage/ArticleTag'
import {
  images,
  articelsHomePageImages,
} from '../../../services/images.service'
import { useMemo, useState } from 'react'
import { useAuthorMap } from '../../../hooks/useAuthorMap'
import { useSelector } from 'react-redux'
import { CommentIcon, HeartIcon } from '../../ui/icons/shared'
import { PostDetailsHeader } from './PostDetailsHeader'
import { PostDetailsContent } from './PostDetailsContent'
import { PostEngagementPanel } from './PostEngagementPanel'
import { PostSidebarInfo } from './PostSidebarInfo'

function extractHeadingsFromContent(content) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  const headings = Array.from(doc.querySelectorAll('h2')).map(
    (heading, index) => {
      const id = `heading-${index}`
      heading.id = id
      return { id, text: heading.innerText }
    }
  )
  return { updatedContent: doc.body.innerHTML, headings }
}

export const PostDetailsMainContent = (props) => {
  const {
    selectedPost,
    loggedInUser,
    handleToggleLike,
    setIsEditing,
    handleRemovePost,
  } = props

  const [isTOCOpen, setIsTOCOpen] = useState(false)
  const authorMap = useAuthorMap()
  const author = authorMap[selectedPost?.author?.userId]

  const postCount = author?.postCount ?? 0
  const { updatedContent, headings } = useMemo(() => {
    return extractHeadingsFromContent(selectedPost.content)
  }, [selectedPost.content])

  const toggleTOC = () => {
    setIsTOCOpen((prevState) => !prevState)
  }

  return (
    <>
      <div className="mt-[30px]">
        <div className="lg:grid lg:grid-cols-[50%_20%_30%]  md:w-[80%] mx-auto lg:relative">
          {/* תוכן עניינים */}
          <div>
            <div className="hidden lg:block">
              <PostDetailsHeader post={selectedPost} />
            </div>

            <PostDetailsContent content={selectedPost.content} />
          </div>
          {/* Social Media Desktop */}
          <PostEngagementPanel
            post={selectedPost}
            loggedInUser={loggedInUser}
            onToggleLike={handleToggleLike}
          />
          {/* User Info & Banners */}
          <PostSidebarInfo
            post={selectedPost}
            author={author}
            postCount={postCount}
            loggedInUser={loggedInUser}
            onEdit={() => setIsEditing(true)}
            onRemove={handleRemovePost}
          />
        </div>
      </div>
    </>
  )
}
